export default "__VITE_ASSET__TcGOdzDI__"